import styled, { css } from 'styled-components'
import {
  Noto_body1_r16,
  Noto_body2_b14,
  Noto_body3_r12,
  Noto_subheading_r18,
} from 'src/styles/font/NotoSansKrFonts'
import { Roboto_num1_r18 } from 'src/styles/font/RobotoFonts'
import icon_check from 'src/assets/images/icon/icon-check.svg'
import icon_check_default from 'src/assets/images/icon/icon-check-default.svg'

export const BillLetterFormStyle = {
  BillLetterFormContainer: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 720px;
    width: 100%;
    margin: 0 auto;
  `,

  CertFormContainer: styled.div`
    display: flex;
    flex-direction: column;
    padding: 40px 20px 20px 20px;
  `,

  PaidNotiText: css`
    margin: 50px auto;
    ${Noto_body2_b14};
    font-size: 14px !important;
    color: #f3223c;
    padding: 0;
  `,
  JoinSubmitFixedButton: (hiddenElement: boolean) => css`
    opacity: 1;
    width: 100%;
    height: 44px;
    background-color: #3617ce;
    border-radius: 0;
    border: none;
    position: fixed;
    bottom: 0;
    ${Noto_body1_r16};
    color: white;
    max-width: 720px;
    transition: opacity 0.5s ease-out;
    ${hiddenElement &&
    css`
      opacity: 0;
    `};
  `,
  JoinSubmitButton: ({
    backgroundColor,
    fontColor,
    fontSize,
    fontWeight,
    borderRadius,
    letterSpacing,
  }: {
    backgroundColor: string
    borderRadius: string
    fontColor: string
    fontSize: string
    fontWeight: number
    letterSpacing: string
  }) => css`
    width: 100%;
    background-color: ${backgroundColor || 'var(--brand-50)'};
    border-radius: ${borderRadius || '5ㅔㅌ'};
    color: ${fontColor || 'var(--white)'};
    font-size: ${fontSize || '14px'};
    font-weight: ${fontWeight || 700};
    letter-spacing: ${letterSpacing || '0'};
    height: 50px;
    border: none;

    &:disabled {
      background: #bfbebe;
      color: white;
    }
    &:active {
      background-color: ${backgroundColor || 'var(--brand-50)'};
      opacity: 0.9;
    }
  `,

  OtpFormContainer: styled.div`
    width: 100%;
    display: flex;
  `,
  Timer: styled.div`
    ${Roboto_num1_r18};
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 81px;
    color: #3617ce;
  `,

  CertFormContents: styled.div`
    display: flex;
    position: relative;
  `,

  BillInputStyle: css`
    height: 58px;
    width: 100%;
    border-radius: 5px;
    padding: 12px 80px 12px 16px;
  `,

  OtpRequestButton: css`
    min-width: 65px;
    height: 40px;
    border-radius: 5px;
    background-color: #3617ce;
    border: none;
    position: absolute;
    right: 8px;
    top: 8px;
    ${Noto_subheading_r18};
  `,

  RetryRequestButton: css`
    min-width: 65px;
    height: 40px;
    border-radius: 0;
    background: transparent;
    color: #3617ce;
    position: absolute;
    right: 8px;
    top: 8px;
    ${Noto_subheading_r18};
    border: none;
  `,

  OtpVerifyButton: () => css`
    ${BillLetterFormStyle.OtpRequestButton};
    color: white;
    background-color: #3617ce;
    padding: 2px;
  `,
  BillJoinTermsWrap: styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid #ccc;
    padding: 20px 10px;
    margin: 26px auto;
  `,

  BillJoinTermsOpenDetail: styled.button.attrs({ type: 'button' })`
    ${Noto_body3_r12};
    color: var(--black-50);
    text-decoration: unset;
    flex-shrink: 0;
  `,

  BillJoinTermsItem: styled.div<{ type: 'all' | 'each' }>`
    display: flex;
    ${(props) =>
      props.type === 'each' &&
      css`
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;

        not:last-child {
          margin-bottom: 10px;
        }
      `}
    ${(props) =>
      props.type === 'all' &&
      css`
        align-items: center;
      `}
  `,

  BillEachTermsContainer: styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
    width: 80%;
  `,
  BillFormCheckboxLabel: styled.label<{ type: 'all' | 'each'; $label_active?: boolean }>`
    ${(props) =>
      props.type === 'each' &&
      css`
        ${Noto_body3_r12};
      `}
    ${(props) =>
      props.type === 'all' &&
      css`
        ${Noto_body1_r16};
      `}
        user-select: none;
    word-break: keep-all;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    gap: 10px;
    align-items: center;
    color: ${(props) => (props.$label_active ? 'var(--black-100)' : '#bfbebe')};
    font-weight: ${(props) => (props.$label_active ? 700 : 400)};
  `,

  BillFormCheckbox: styled.input.attrs({ type: 'checkbox' })<{ $actColor?: string }>`
    position: relative;
    cursor: pointer;
    flex-shrink: 0;
    border: 1px solid var(--black-20);
    border-radius: 6px;
    width: 20px;
    height: 20px;
    background: var(--white);
    overflow: hidden;
    transition:
      background 0.3s ease,
      opacity 0.3s ease;
    &:checked {
      background: url(${icon_check}) no-repeat center/cover;
      background-color: ${(props) => props.$actColor || 'rgb(54, 23, 206)'};
      border: 0;
      opacity: 1;
    }
    &:not(:checked) {
      opacity: 0.5;
      background: url(${icon_check_default}) no-repeat center/cover;
    }
  `,
}
